import { useState, type FormEvent } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { api, ApiFehler } from '../api/client.js';
import { useAuth } from '../auth/AuthKontext.js';

// Rücksprung nach der Anmeldung nur auf bekannte Seiten des Portals (keine fremden oder protokollrelativen Ziele).
const ERLAUBTES_ZIEL = /^\/(standorte(\/import|\/[0-9a-f-]{36})?|gebiet\/[a-z0-9-]+|hinweise|lieferung|verwaltung(\/(lieferungen|lieferstand|nutzer))?)?(\?[A-Za-z0-9=&%._-]*)?$/;

export function Anmelden() {
  const { zustand } = useAuth();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'eingabe' | 'sendet' | 'gesendet'>('eingabe');
  const [fehler, setFehler] = useState<string | null>(null);

  if (zustand.status === 'bereit' && zustand.ich.angemeldet) {
    const weiter = params.get('weiter');
    return <Navigate to={weiter && ERLAUBTES_ZIEL.test(weiter) ? weiter : '/standorte'} replace />;
  }

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    setStatus('sendet');
    try {
      await api('/anmeldung/anfordern', { methode: 'POST', json: { email } });
      setStatus('gesendet');
    } catch (f) {
      setStatus('eingabe');
      setFehler(f instanceof ApiFehler && f.code === 'eingabe_ungueltig' ? 'Bitte eine gültige E-Mail-Adresse eingeben.' : (f as Error).message);
    }
  }

  return (
    <div className="seite seite-schmal">
      <h1>Anmelden</h1>
      {status === 'gesendet' ? (
        <div className="hinweis-kasten" role="status">
          <p>
            <strong>Bitte prüfen Sie Ihr Postfach.</strong>
          </p>
          <p>
            Ist die Adresse für das Portal freigeschaltet, erhalten Sie in wenigen Minuten einen Anmeldelink. Er ist 30
            Minuten gültig und nur einmal verwendbar.
          </p>
          <button type="button" className="text-knopf" onClick={() => setStatus('eingabe')}>
            Andere Adresse eingeben
          </button>
        </div>
      ) : (
        <form onSubmit={absenden} noValidate>
          <p>Das Portal steht einem geschlossenen Nutzerkreis offen. Sie erhalten einen Anmeldelink per E-Mail; ein Passwort gibt es nicht.</p>
          <label className="feld">
            <span className="feld-label">E-Mail-Adresse</span>
            <input
              type="email"
              autoComplete="email"
              inputMode="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-invalid={!!fehler}
              aria-describedby={fehler ? 'anmelden-fehler' : undefined}
            />
          </label>
          {fehler && (
            <p id="anmelden-fehler" className="fehlertext" role="alert">
              {fehler}
            </p>
          )}
          <button type="submit" className="knopf knopf-breit" disabled={status === 'sendet' || !email}>
            {status === 'sendet' ? 'Wird gesendet …' : 'Anmeldelink anfordern'}
          </button>
        </form>
      )}
    </div>
  );
}
